module.exports = new __parcel__URL__("battlepass_background.6b1c8267.png").toString();